export enum EmployeeInvitationStatus {
  COMPLETED = 'COMPLETED',
  INVITED = 'INVITED',
}
